/**
 * Replaces Bold's not-logged-in message on /pages/manage-subscriptions with our
 * own copy pointing at the GreaterGood store login. Only rendered on that page
 * (see the Liquid guard in layout/theme.liquid). Moved out of the layout (inline).
 */
document.addEventListener('DOMContentLoaded', function () {
	let retries = 0;
	const maxRetries = 30;
	const interval = setInterval(function () {
		const messageSpan = document.querySelector('.bsub-auth-message__flex span');
		if (messageSpan) {
			messageSpan.style.opacity = 0;
			messageSpan.innerHTML = `
	<p style="font-size: 1.75rem; line-height: 1.5; text-wrap: pretty;">
	  We apologize for the inconvenience, subscriptions can only be managed via our GreaterGood store.
	  Please <a href="https://greatergood.com/account/login" target="_blank" rel="noopener noreferrer" style="font-weight: bolder;">log in again HERE</a> to access subscription management.
	</p>`;
				messageSpan.style.transition = 'opacity 0.3s ease-in';
				requestAnimationFrame(() => {
					messageSpan.style.opacity = 1;
				});
				clearInterval(interval);
			}
			retries++;
			if (retries >= maxRetries) clearInterval(interval);
		}, 100);
	});
